/* global fetch */
import I18n from 'lib/i18n'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Bugsnag from '~/scenes/bugsnag'

import ErrorIllustrationLogo from './assets/error-illustration.svg'

import './styles.scss'

function logError (error) {
  let body = {
    ua: navigator.userAgent,
    message: error.message,
    file: `${error.fileName}:${error.lineNumber}:${error.columnNumber}`,
    stacktrace: error.stack
  }

  fetch &&
    fetch('/_log_error', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
}

export default class ErrorBoundary extends Component {
  static propTypes = {
    className: PropTypes.string,
    errorClassName: PropTypes.string
  }

  static defaultProps = {
    className: '',
    errorClassName: 'has-errors'
  }

  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true })
    logError(error)
    Bugsnag.notify(error)
  }

  render () {
    return (
      <div
        className={this.state.hasError ? `${this.props.className} ${this.props.errorClassName}` : this.props.className}
      >
        {this.state.hasError ? (
          <>
            <img src={ErrorIllustrationLogo} width='213px' height='161px' className='error-logo' />
            <div className='error-text-container'>
              <p className='first-level-error-text'>{I18n.t('errors.first_level_error_text')}</p>
              <span className='second-level-error-text' dangerouslySetInnerHTML={{ __html: I18n.t('errors.error') }} />
              &nbsp;
              <a href='/help' target='_blank'>
                {I18n.t('errors.contact')}
              </a>
            </div>
          </>
        ) : (
          this.props.children
        )}
      </div>
    )
  }
}
